import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import Element from "element-ui";
import locale from "element-ui/lib/locale/lang/ko";
import VueI18n from "vue-i18n";
import VueCookies from "vue-cookies";
import VueMobileDetection from "vue-mobile-detection";
import { sync } from "vuex-router-sync";
import VueMoment from "vue-moment";
import VueCountdown from "@chenfengyuan/vue-countdown";

import router from "./router";
import store from "./store";
import "./filters";
import init from "./init";
import App from "@/views/App";

import en from "@/utils/locale/en.json";
import ko from "@/utils/locale/ko.json";
import "./components/common.js";
import "./utils/index.js";
import "jquery-ui";
import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(Element, { size: "large", locale });
Vue.use(VueI18n);
Vue.use(VueCookies);
Vue.use(VueMobileDetection);
Vue.use(VueMoment);
Vue.use(VueMeta);

Vue.component(VueCountdown.name, VueCountdown);
Vue.use(
  VueGtag,
  {
    config: {
      id: "G-HNCGB8PKFW",
    },
  },
  router
);

sync(store, router);

require("jquery");
global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

init();

const messages = {
  en,
  ko,
};

const app = new Vue({
  i18n: new VueI18n({
    locale: "ko",
    fallbackLocale: "ko",
    messages,
  }),
  el: "#app",
  data: {
    loading: null,
    loading2: null,
  },
  router,
  store,
  template: "<App/>",
  components: { App },
});
